import React, { Component } from 'react';
import './FidelityPoint.scss';
import { connect } from 'react-redux';
import { loadFideltyPoints } from '../../../redux/modules/fideltyCard';
import Link from '../Link/Link';
import { ImageDispatcher } from '../ImageDispatcher/ImageDispatcher';

class FidelityPoint extends Component {
  componentDidMount() {
    if (!!this.props.user.authenticated) {
      this.props.loadFideltyPoints();
    }
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.user.authenticated !== prevProps.user.authenticated &&
      !!this.props.user.authenticated
    ) {
      this.props.loadFideltyPoints();
    }
  }

  render() {
    const { borderRatio, width, primaryColor } = this.props;

    const fidelityStyle = {
      '--primary-color': primaryColor,
    };

    return (
      <div
        style={{
          borderRadius: borderRatio,
          width: width,
          ...fidelityStyle,
        }}
        className="fidelity-container"
      >
        <ImageDispatcher
          className="fidelity-diamond"
          alt="diamante"
          src="/static/images/fidelity_point_logo.png"
        />
        <div className="fidelity-point">
          <br />
          Fidelity point
        </div>
        {!this.props.user.authenticated ? (
          <p className="fidelity-desc">
            <span className="text-wrapper">
              <Link to="/login" style={{ color: primaryColor }}>
                Accedi
              </Link>{' '}
              o{' '}
              <Link to="/registrati" style={{ color: primaryColor }}>
                registrati
              </Link>{' '}
              per vedere il saldo dei tuoi punti
            </span>
          </p>
        ) : (
          <p className="fidelity-desc">
            <span className="text-wrapper">Hai accumulato </span>
            <span className="span">{this.props.userPoints} punti</span>
          </p>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    userPoints: state.card.points,
    primaryColor: state.store.data.loghiTemplate.brandColor,
  };
};

export default connect(mapStateToProps, {
  loadFideltyPoints,
})(FidelityPoint);
